// extracted by mini-css-extract-plugin
export default {"container":"styles_container__QfNLi","page_btn":"styles_page_btn__HhBAW","active":"styles_active__lj0-U"};